"use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _View = _interopRequireDefault(require("../View"));
var _excluded = [
    "behavior",
    "contentContainerStyle",
    "keyboardVerticalOffset"
];
var KeyboardAvoidingView = /*#__PURE__*/ function(_React_Component) {
    _inherits(KeyboardAvoidingView, _React_Component);
    var _super = _create_super(KeyboardAvoidingView);
    function KeyboardAvoidingView() {
        _class_call_check(this, KeyboardAvoidingView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.frame = null;
        _this.onLayout = function(event) {
            _this.frame = event.nativeEvent.layout;
        };
        return _this;
    }
    _create_class(KeyboardAvoidingView, [
        {
            key: "relativeKeyboardHeight",
            value: function relativeKeyboardHeight(keyboardFrame) {
                var frame = this.frame;
                if (!frame || !keyboardFrame) {
                    return 0;
                }
                var keyboardY = keyboardFrame.screenY - (this.props.keyboardVerticalOffset || 0);
                return Math.max(frame.y + frame.height - keyboardY, 0);
            }
        },
        {
            key: "onKeyboardChange",
            value: function onKeyboardChange(event) {}
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, behavior = _this$props.behavior, contentContainerStyle = _this$props.contentContainerStyle, keyboardVerticalOffset = _this$props.keyboardVerticalOffset, rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
                return /*#__PURE__*/ React.createElement(_View.default, (0, _extends2.default)({
                    onLayout: this.onLayout
                }, rest));
            }
        }
    ]);
    return KeyboardAvoidingView;
}(React.Component);
var _default = KeyboardAvoidingView;
exports.default = _default;
module.exports = exports.default;
